// Source: https://github.com/thoughtspile/VKUI/blob/master/src/lib/dom.ts

export const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)
